const SetupAdvancedCustomerActionTypes = {
  GET_ADVANCED_CUSTOMER_START: 'GET_ADVANCED_CUSTOMER_START',
  GET_ADVANCED_CUSTOMER_SUCCESS: 'GET_ADVANCED_CUSTOMER_SUCCESS',
  GET_ADVANCED_CUSTOMER_FAILURE: 'GET_ADVANCED_CUSTOMER_FAILURE',
};

export default SetupAdvancedCustomerActionTypes;
